import { Typography } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';

const Belts = ({ control, tableView }) => {    
    return (
        <>
            {!tableView ? <Typography variant="h6" gutterBottom>Belts</Typography> : <br/>}
            <ReactHookTextField
                name='attributes.driveBeltQty'
                type='text'
                control={control}
                label='Qty'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.driveBeltType'
                type='text'
                control={control}
                label='Type'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.driveBeltCentres'
                type='text'
                control={control}
                 
                label='Belt Centres'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.driveBeltTension'
                type='text'
                control={control}
                label='Belt Tension'
                style={{width: '19%', marginRight: '1%'}}
            />
        </>   
    );
};

export default Belts;
